import { render, staticRenderFns } from "./PlayerAttachmentsButton.vue?vue&type=template&id=65428c80&scoped=true&"
import script from "./PlayerAttachmentsButton.vue?vue&type=script&lang=js&"
export * from "./PlayerAttachmentsButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAttachmentsButton.vue?vue&type=style&index=0&id=65428c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65428c80",
  null
  
)

export default component.exports